module.exports = __webpack_public_path__ + "static/media/error.27e8619f.svg";